import React from 'react'

import { Input } from 'antd'

const { Search } = Input

export type SimpleSearchProps = {
  placeholder?: string
  allowClear?: boolean
  onSearch?: (value: string) => void
  defaultValue?: string | undefined
}
const SimpleSearch = (props: SimpleSearchProps) => {
  return (
    <Search
      placeholder={props.placeholder}
      allowClear={props.allowClear}
      onSearch={props.onSearch}
      defaultValue={props.defaultValue}
    />
  )
}

export default SimpleSearch
